// extracted by mini-css-extract-plugin
export default {"root":"ClientProfileHeader_root__PKinL","title":"ClientProfileHeader_title__BaC2J","wrapper":"ClientProfileHeader_wrapper__Q1uM6"};